
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_1r4p6_nvzqm_11",
  "awsui-motion-fade-in-tooltip": "awsui_awsui-motion-fade-in-tooltip_1r4p6_nvzqm_1"
};
  